import { render, staticRenderFns } from "./TeleMarketUserGroupTypeConfigEdit.vue?vue&type=template&id=3bddde82&scoped=true"
import script from "./TeleMarketUserGroupTypeConfigEdit.vue?vue&type=script&lang=js"
export * from "./TeleMarketUserGroupTypeConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bddde82",
  null
  
)

export default component.exports